import React, { useState } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';
import { Card } from './ui/card';

const BeforeAfterGallery = ({ projects }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <Carousel className="w-full max-w-5xl mx-auto">
      <CarouselContent>
        {projects.map((project, index) => (
          <CarouselItem key={project.id}>
            <Card className="p-6 bg-white shadow-xl rounded-2xl border-2 border-gray-200">
              <h3 className="text-2xl font-bold text-center mb-6 text-gray-900">{project.title}</h3>
              <div className="grid md:grid-cols-2 gap-6">
                {/* Before Image */}
                <div className="space-y-3">
                  <div className="relative overflow-hidden rounded-xl">
                    <div className="absolute top-3 left-3 bg-red-500 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg z-10">
                      BEFORE
                    </div>
                    <img 
                      src={project.before} 
                      alt={`${project.title} - Before`}
                      className="w-full h-80 object-cover transition-transform hover:scale-105 duration-300"
                    />
                  </div>
                </div>
                
                {/* After Image */}
                <div className="space-y-3">
                  <div className="relative overflow-hidden rounded-xl">
                    <div className="absolute top-3 left-3 bg-green-600 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg z-10">
                      AFTER
                    </div>
                    <img 
                      src={project.after} 
                      alt={`${project.title} - After`}
                      className="w-full h-80 object-cover transition-transform hover:scale-105 duration-300"
                    />
                  </div>
                </div>
              </div>
            </Card>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="-left-12 bg-[#FFC222] hover:bg-[#E6AE12] text-black border-none shadow-lg" />
      <CarouselNext className="-right-12 bg-[#FFC222] hover:bg-[#E6AE12] text-black border-none shadow-lg" />
    </Carousel>
  );
};

export default BeforeAfterGallery;
